import React from 'react';
import { connect } from 'react-redux';
import { CommentEntityType } from '@core/utils/commentsEntityTypes';
import {
  accessToken as getAccessToken,
  currentUserId as getCurrentUserId,
} from '@core/selectors/user';
import { getMaterialPlacementLtiProviders } from '@core/selectors/lti';
import { currentClassRoomId, isInstructor } from '@core/selectors/classroom';
import AulaEditorWithAnalyticsWithoutPlugins from '../../../common/AulaEditor/AulaEditorWithAnalyticsWithoutPlugins';
import AulaEditorWithAnalytics from '../../../common/AulaEditor/AulaEditorWithAnalytics';
import ResponsiveCommentEditor from './ResponsiveCommentEditor';

type OwnProps = {
  entityId: string;
  entityType: CommentEntityType;
  parent?: string;
  root?: string;
  onCancel?: () => void;
  onSuccess?: () => void;
  autoFocus?: boolean;
};

const mapStateToProps = (state: any) => {
  const userId = getCurrentUserId(state);
  const spaceId = currentClassRoomId(state);
  const isEducator = isInstructor(state, userId);

  return {
    user: state.user.user,
    isCreatingComment: state.comment.isCreatingComment,
    spaceId,
    isEducator,
    accessToken: getAccessToken(state, spaceId),
    institution: state.institution.general.institution,
    ltiProviders: getMaterialPlacementLtiProviders(state),
    EditorComponent: isEducator
      ? AulaEditorWithAnalytics
      : AulaEditorWithAnalyticsWithoutPlugins,
  };
};

export default connect<any, any, OwnProps>(mapStateToProps)(
  ResponsiveCommentEditor
) as React.ComponentType<OwnProps>;
